import I18n from "i18n-js";
import React from "react"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import DateHelper from "../DateHelper/DateHelper";

export default class TextStatusViewer extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      success: null,
      phone_changed: false
    }

    this.onDismissSuccess = this.onDismissSuccess.bind(this)
    this.onSendOptin = this.onSendOptin.bind(this)
    this.renderTimeStamp = this.renderTimeStamp.bind(this)
  }

  componentDidUpdate(prevProps) {
    if(this.props.phone_number != prevProps.phone_number) {
      this.setState({phone_changed: true})
    }
  }

  render() {
    return (
      <div className="card" style={{ fontSize: '11px', position: 'relative', padding: '1rem' }}>
        {this.renderSuccess()}
        {this.renderTitle()}
        <div>{I18n.t('opted_in')}: {this.props.opted_in_at ? this.renderTimeStamp(this.props.opted_in_at) : I18n.t('na')}</div>
        <div>{I18n.t('opted_out')}: {this.props.opted_out_at ? this.renderTimeStamp(this.props.opted_out_at) : I18n.t('na')}</div>
        {this.props.phone_number
        ?
        <div>
          <hr />
          <div className='btn-group action-group button-group-2'>
            <div><button type="button" onClick={this.onSendOptin} className="btn btn-sm btn-secondary" disabled={this.state.phone_changed}>{I18n.t('send_opt_in')}</button></div>
            { this.state.phone_changed ? <span className="ss-alert d-flex align-items-center ml-1" title={I18n.t('save_before_sending_opt_in')}></span> : null}
          </div>
        </div>
        :
        null
        }
        <LoadingSpinner show={this.state.loading} />
      </div>
    )
  }

  renderSuccess() {
    if (this.state.success) {
      return (
        <div className="alert alert-success alert-dismissible fade show" role="alert">
          {this.state.success}
          <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label={I18n.t('close')} onClick={this.onDismissSuccess} style={{
            fontWeight: 'bold', fontSize: '21px', background: 'transparent', border: '0',
            position: 'absolute', right: '5px', top: '7px', color: '#777'
          }}>×</button>
        </div>
      )
    }
  }

  onDismissSuccess() {
    this.setState({ success: null })
  }
  
  renderTitle() {
    return (
      <h3>{I18n.t('text_messaging')}</h3>
    )
  }

  renderTimeStamp(timestamp) {
    return (
      DateHelper.printDateToScreen(
        timestamp,
        'PPPpp',
        true
      )
    )
  }

  onSendOptin() {
    this.setState({ loading: true, })
    $.ajax({
      type: 'POST',
      url: this.props.send_opt_in_path,
      data: {
        phone_number: this.props.phone_number
      }
    }).done((data) => {
      this.setState({ loading: false, success: I18n.t('opt_in_message_sent_successfully') })
    });
  }
}
